import { FamilyTreeNode } from '../types/familyTree';

/** Strip maternal/paternal prefixes — position on the tree implies side. */
export function formatSimpleRelationLabel(relationKey: string, fallback = ''): string {
  const key = (relationKey || '').toLowerCase();
  if (key === 'self') return 'You';
  if (!key) return fallback || 'Relative';

  const simple = key
    .replace(/^(maternal|paternal)_/, '')
    .replace(/_/g, ' ')
    .trim();

  if (!simple) return fallback || 'Relative';
  return simple.charAt(0).toUpperCase() + simple.slice(1);
}

export function displayRelationLabel(node: FamilyTreeNode): string {
  if (node.relationKey === 'self') {
    return node.relationLabel?.trim() || 'You';
  }
  return formatSimpleRelationLabel(node.relationKey, node.relationLabel);
}

export function treeNodeTitle(node: FamilyTreeNode): string {
  if (node.relationKey === 'self') return 'You';
  return formatSimpleRelationLabel(node.relationKey, node.relationLabel);
}

export function hasConditionOnRecord(node: FamilyTreeNode): boolean {
  return node.healthSignal === 'affected' || node.healthSignal === 'monitored' || node.conditions.length > 0;
}

export function melioRecordText(node: FamilyTreeNode): string {
  return (node.melioNotes || node.caption || '').trim();
}

export function personalNotesText(node: FamilyTreeNode): string {
  return (node.notes || '').trim();
}
